import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {
  IS_PRIVATE,
  NOT_APPLY,
  PANEL_FINANCING_VERSION,
  WITH_DISCOUNT,
  WITH_DISCOUNT_AND_MAX_ENTRY_EXCEEDED,
  WITH_DISCOUNT_AND_MAX_ENTRY_NOT_EXCEEDED,
  WITHOUT_DISCOUNT
} from '../components/config.js'

const FINANCING_TERMS_CONDITIONS_ID = 'mt-Detail-financingTerms'
const CONTACT_SELLER_ID = 'form-contact-seller-id'
const scrollParams = {behavior: 'smooth', block: 'center'}

export const useUtils = () => {
  const {i18n} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const getInputBottomText = ({maxEntry, minEntry, value}) => {
    const formattedValue = Number(value)
    if (formattedValue < minEntry) return i18n.t('ENTRY_MINIMUM_VALUE', {amount: i18n.c(minEntry)})
    if (formattedValue >= maxEntry) return i18n.t('ENTRY_MAXIMUM_VALUE', {amount: i18n.c(maxEntry)})
    return ''
  }

  const getValueFormated = value =>
    Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(value)

  const getEntryConditionDealerKey = ({
    cashPrice,
    entry,
    financedPrice,
    isProfessional,
    maxEntryToGetDiscount,
    selectedOption
  }) => {
    if (cashPrice === financedPrice) return NOT_APPLY
    if (selectedOption === WITHOUT_DISCOUNT) return selectedOption
    if (selectedOption === WITH_DISCOUNT) {
      return maxEntryToGetDiscount - Number(entry) < 0
        ? WITH_DISCOUNT_AND_MAX_ENTRY_EXCEEDED
        : WITH_DISCOUNT_AND_MAX_ENTRY_NOT_EXCEEDED
    }
    if (!isProfessional) return IS_PRIVATE
  }

  const getInputHelpText = ({
    minEntry,
    maxEntry,
    cashPrice,
    entry,
    financedPrice,
    isProfessional,
    maxEntryToGetDiscount,
    selectedOption
  }) => {
    const entryDealerCondition = getEntryConditionDealerKey({
      cashPrice,
      entry,
      financedPrice,
      isProfessional,
      maxEntryToGetDiscount,
      selectedOption
    })

    switch (entryDealerCondition) {
      case WITHOUT_DISCOUNT:
        return i18n.t('PANEL_FINANCING.B2C.INPUT_HELP_TEXT_WITHOUT_DISCOUNT')
      case WITH_DISCOUNT_AND_MAX_ENTRY_NOT_EXCEEDED:
        return i18n.t('PANEL_FINANCING.B2C.INPUT_HELP_TEXT_WITH_DISCOUNT_MAX_ENTRY_NOT_EXCEEDED')
      case WITH_DISCOUNT_AND_MAX_ENTRY_EXCEEDED:
        return i18n.t('PANEL_FINANCING.B2C.INPUT_HELP_TEXT_WITH_DISCOUNT_MAX_ENTRY_EXCEEDED')
      case IS_PRIVATE:
      case NOT_APPLY:
      default:
        i18n.t('COMMON.MINIMUM_MAXIMUM', {
          minimum: i18n.c(minEntry),
          maximum: i18n.c(maxEntry)
        })
    }
  }

  const handleScrollToFinancingTerms = () => {
    const elementContactForm = document.getElementById(FINANCING_TERMS_CONDITIONS_ID)
    elementContactForm && elementContactForm.scrollIntoView(scrollParams)
  }

  const handleScrollToContactSeller = ({ad} = {}) => {
    track({
      event: 'Instalment Contact Button Clicked',
      data: {
        hit_origin: 'detail',
        products: [{id: ad?.id, category: 'ads', price: ad?.price, quantity: 0}]
      }
    })
    const elementContactSeller = document.getElementById(CONTACT_SELLER_ID)
    elementContactSeller && elementContactSeller.scrollIntoView(scrollParams)
  }

  const getPanelFinancingVersion = ({isProfessional, loanCalculations}) => {
    const isCalculatorB2cDataAvailable =
      Boolean(loanCalculations?.calculatorB2cData) && Object.keys(loanCalculations?.calculatorB2cData).length === 2
    if (!isProfessional && !isCalculatorB2cDataAvailable) return PANEL_FINANCING_VERSION.C2C
    if (isProfessional && !isCalculatorB2cDataAvailable) {
      return PANEL_FINANCING_VERSION.SIMPLIFIED
    }
    return PANEL_FINANCING_VERSION.B2C
  }

  return {
    getInputBottomText,
    getValueFormated,
    getInputHelpText,
    getPanelFinancingVersion,
    handleScrollToFinancingTerms,
    handleScrollToContactSeller
  }
}
